import { z } from 'zod';

const maxFileSize = 5000000;
const acceptedImageTypes = ['image/jpeg', 'image/jpg', 'image/png'];

const validationSchema = z.object({
  firstname: z.string({ required_error: 'Please enter your name' }).min(1).max(50),
  lastname: z.string({ required_error: 'Please enter your last name' }).min(1).max(50),
  phoneNumber: z
    .string({ required_error: 'Please enter your mobile phone number' })
    .min(10, 'Min length should be 10 digits')
    .max(13, 'Max length should be 13 digits'),
  photoFiles: z
    .any()
    .refine(
      files => acceptedImageTypes.includes(files?.[0]?.type),
      'Only .jpg, .jpeg, and .png formats are supported.'
    )
    .refine(files => files?.[0]?.size < maxFileSize, `Max image size is 5Mb.`)
    .or(z.any().optional()),
});

export default validationSchema;
